module.exports = __webpack_public_path__ + "img/Besties.eb798f38.svg";